import {
  GET_VENDORS,
  SET_VENDORS,
  GET_VENDORS_LIST,
  SET_VENDORS_LIST,
  SET_VENDOR,
  ADD_VENDOR,
  EMPTY_VENDOR,
  DELETE_VENDOR,
  EDIT_VENDOR,
  UPDATE_VENDOR,
  SET_VENDOR_FILTER,
  GET_VENDOR_RELATIONS,
  SET_VENDOR_RELATIONS,
  API_ERROR,
  SET_VENDOR_RELATION_FILTER,
  GET_VENDOR_PRICE_LOGS,
  SET_VENDOR_PRICE_LOGS,
  SET_VENDOR_PRICE_LOGS_FILTER,
  GET_VENDORS_LIST_CLIENT,
  SET_VENDORS_LIST_CLIENT,
} from "./actionTypes";

export const getVendorPriceLogs = (id) => {
  return {
    type: GET_VENDOR_PRICE_LOGS,
    payload: {id},
  };
};

export const setVendorPriceLogs = (data) => {
  return {
    type: SET_VENDOR_PRICE_LOGS,
    payload: data,
  };
};

export const getVendorRelations = (id) => {
  return {
    type: GET_VENDOR_RELATIONS,
    payload: {id},
  };
};

export const setVendorRelations = (data) => {
  return {
    type: SET_VENDOR_RELATIONS,
    payload: data,
  };
};

export const getVendors = () => {
  return {
    type: GET_VENDORS,
    payload: {},
  };
};

export const setVendors = (data) => {
  return {
    type: SET_VENDORS,
    payload: data,
  };
};

export const getVendorsList = () => {
  return {
    type: GET_VENDORS_LIST,
    payload: {},
  };
};

export const setVendorsList = (data) => {
  return {
    type: SET_VENDORS_LIST,
    payload: data,
  };
}

export const getVendorsListClient = () => {
  return {
    type: GET_VENDORS_LIST_CLIENT,
    payload: {},
  };
};

export const setVendorsListClient = (data) => {
  return {
    type: SET_VENDORS_LIST_CLIENT,
    payload: data,
  };
}

export const setVendor = (data) => {
  return {
    type: SET_VENDOR,
    payload: data,
  };
};

export const addVendor = () => {
  return {
    type: ADD_VENDOR,
    payload: {},
  };
};

export const emptyVendor = () => {
  return {
    type: EMPTY_VENDOR,
    payload: {},
  };
};

export const deleteVendor = (id) => {
  return {
    type: DELETE_VENDOR,
    payload: { id },
  };
};

export const editVendor = (id) => {
  return {
    type: EDIT_VENDOR,
    payload: { id },
  };
};

export const updateVendor = (id) => {
  return {
    type: UPDATE_VENDOR,
    payload: { id },
  };
};

export const setVendorFilter = (data) => {
  return {
    type: SET_VENDOR_FILTER,
    payload: data,
  };
};

export const setVendorRelationFilter = (data) => {
  return {
    type: SET_VENDOR_RELATION_FILTER,
    payload: data,
  };
};

export const setVendorPriceLogsFilter = (data) => {
  return {
    type: SET_VENDOR_PRICE_LOGS_FILTER,
    payload: data,
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
